import { z } from "zod";

import {
  insertPayersTypeSchema,
  publicInvoiceDeliveryMethodEnumSchema,
  publicPayerGroupEnumSchema,
  rowPayersTypeSchema,
} from "@libs/schemas";
import { formatInvoiceDeliveryMethod, formatPayerGroup } from "@/utils/payers";

export const DEFAULT_PAYER_NAME = "TTCC Catch All";

export const payerSchema = rowPayersTypeSchema;
export type PayerType = z.infer<typeof payerSchema>;

export type PayerGroupType = z.infer<typeof publicPayerGroupEnumSchema>;
export type InvoiceDeliveryMethodType = z.infer<
  typeof publicInvoiceDeliveryMethodEnumSchema
>;

export const payerFormSchema = insertPayersTypeSchema
  .omit({
    id: true,
    created_at: true,
    updated_at: true,
    full_text_search: true,
  })
  .extend({
    name: z.string().min(1),
    email: z.string().email(),
    phone_number: z.string().min(1),
    billing_address: z.string().min(1),
    invoice_attention_to: z.string().min(1),
    invoice_delivery_emails: z.array(z.string().email()).min(1),
    student_id: z.string().uuid().nullable().optional(),
  });
export type PayerFormType = z.infer<typeof payerFormSchema>;

const payerFilterSchema = z.object({
  search: z.string().optional().catch(""),
  groupTypes: z.array(publicPayerGroupEnumSchema).optional().catch([]),
});
export type PayerFilterType = z.infer<typeof payerFilterSchema>;

export const payerSearchParamsSchema = payerFilterSchema.extend({
  id: z.string().uuid().optional().catch(""),
});

export const payerGroupOptions = publicPayerGroupEnumSchema.options.map(
  group => ({
    label: formatPayerGroup(group),
    value: group,
  }),
);

export const invoiceDeliveryMethodOptions =
  publicInvoiceDeliveryMethodEnumSchema.options.map(method => ({
    label: formatInvoiceDeliveryMethod(method),
    value: method,
  }));
